import ListQuizBackOffice from './list';

export default ListQuizBackOffice;
